import { toast } from "react-toastify";
import { BaseApplicationService } from "../../domain/base/base-application-service";
import apiClient from "../../apis/api-client";
import { getFriendlyErrorMessage } from "../../util/error-message-mapper";
import { defaultShortcut, Shortcut } from "../../domain/ttzk-portal";
import { reportTtzkPortalRelatedError } from "../../domain/ttzk-portal/util/error";
import { CloudGovApiError } from "../../domain/api-error";

export type ShortcutDetailContextProps = {
  shortcut: Shortcut;
  fetchShortcutByID: (shortcutId: string) => Promise<void>;
  onPublish: () => void;
  onUnPublish: () => void;
};

export class TtzkPortalShortcutDetailService extends BaseApplicationService<ShortcutDetailContextProps> {
  state = {
    shortcut: <Shortcut>{
      id: "",
      createdAt: "",
      updatedAt: "",
      ...defaultShortcut,
    },
    fetchShortcutByID: this.fetchShortcutById.bind(this),
    onPublish: this.handlePublish.bind(this),
    onUnPublish: this.handleUnPublish.bind(this),
  };

  async fetchShortcutById(shortcutId: string) {
    try {
      const { data } = await apiClient.ttzkPortal.findShortcutById(shortcutId);
      this.setState({
        shortcut: data,
      });
    } catch (error) {
      reportTtzkPortalRelatedError(error);
      const friendlyMessage = getFriendlyErrorMessage(error);
      toast.error(`ショートカットの取得に失敗しました: ${friendlyMessage}`);
    }
  }

  async handlePublish() {
    const { shortcut } = this.state;
    try {
      shortcut.isPublished = true;
      const { data } = await apiClient.ttzkPortal.updateShortcut(shortcut);
      this.setState({
        shortcut: data,
      });
      toast.success("ショートカット情報を公開しました。");
    } catch (error) {
      reportTtzkPortalRelatedError(error);
      if (CloudGovApiError.isTtzkPortalShortcutMaxCountError(error)) {
        toast.error("ショートカットの公開上限を超過しました。");
        return;
      }
      const friendlyMessage = getFriendlyErrorMessage(error);
      toast.error(`ショートカットの公開に失敗しました: ${friendlyMessage}`);
    }
  }

  async handleUnPublish() {
    const { shortcut } = this.state;
    try {
      shortcut.isPublished = false;
      const { data } = await apiClient.ttzkPortal.updateShortcut(shortcut);
      this.setState({
        shortcut: data,
      });
      toast.success("ショートカット情報を下書きに戻しました。");
    } catch (error) {
      reportTtzkPortalRelatedError(error);
      const friendlyMessage = getFriendlyErrorMessage(error);
      toast.error(`ショートカットの非公開に失敗しました: ${friendlyMessage}`);
    }
  }
}
